<script setup lang="ts">
import { Document } from '@contentful/rich-text-types'
import { ButtonProps } from '~/components/ui/Button.vue'
import { ModalVariants } from '~/components/ui/Modal.vue'

type ActionModalProps = {
  button: ButtonProps
  modalContent: {
    content: Document
  }
  modalVariant: ModalVariants
}
const props = defineProps<ActionModalProps>()
const attrs = useAttrs() /* Atts may include gaOptions, other HTML button attrs like: class, aria-label */
const isShowModal = ref(false)
// Mount the content on first open: Modal only v-shows its slot, so it would otherwise render (and fetch) on page load.
const hasOpened = ref(false)
const openModal = () => {
  hasOpened.value = true
  isShowModal.value = true
}
</script>

<template>
  <Button class="rtp-modal__button" @click.prevent="openModal" v-bind="{ ...button, ...attrs }">
    <slot />
  </Button>
  <ClientOnly>
    <Teleport to="body">
      <Modal :variant="modalVariant" :show="isShowModal" @close="isShowModal = false" class="rtp-modal__modal">
        <RichTextPanel v-if="hasOpened" :content="modalContent?.content" :skipContainer="true"></RichTextPanel>
      </Modal>
    </Teleport>
  </ClientOnly>
</template>

<style></style>
